import { useQuery } from '@tanstack/react-query'
import { projectsApi, type Project } from '../services/api'

const Projects = () => {
  const { data: response, isLoading, error, refetch } = useQuery({
    queryKey: ['projects'],
    queryFn: projectsApi.getAll,
    retry: 2
  })

  const projects = response?.data || []

  if (isLoading) {
    return (
      <section id="projects" className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <div className="text-center">
            <div className="inline-block animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
            <p className="mt-4 text-gray-600">正在加载项目...</p>
          </div>
        </div>
      </section>
    )
  }

  if (error) {
    return (
      <section id="projects" className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <div className="text-center">
            <div className="text-red-500 mb-4">❌ 加载失败</div>
            <p className="text-gray-600 mb-4">无法加载项目数据，请稍后重试</p>
            <button
              onClick={() => refetch()}
              className="bg-blue-600 text-white px-6 py-2 rounded-lg hover:bg-blue-700 transition"
            >
              重新加载
            </button>
          </div>
        </div>
      </section>
    )
  }

  // 解析 JSON 格式的 tags
  const parsedProjects = projects.map((project: Project) => ({
    ...project,
    tags: typeof project.tags === 'string' ? JSON.parse(project.tags) : project.tags
  }))

  return (
    <section id="projects" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <h2 className="text-4xl font-bold text-center mb-4 text-gray-900">
          Featured Projects
        </h2>
        <p className="text-center text-gray-600 mb-12">
          来自后端 API 的实时项目数据
        </p>

        {parsedProjects.length === 0 ? (
          <div className="text-center text-gray-500">
            暂无项目数据
          </div>
        ) : (
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {parsedProjects.map((project: any) => (
              <div
                key={project.id}
                className="bg-gray-50 rounded-lg p-6 hover:shadow-lg transition border border-gray-200"
              >
                <h3 className="text-xl font-bold mb-2 text-gray-900">
                  {project.title}
                </h3>
                <p className="text-gray-600 mb-4">
                  {project.description}
                </p>
                <div className="flex gap-2 mb-4 flex-wrap">
                  {Array.isArray(project.tags) && project.tags.map((tag: string, index: number) => (
                    <span
                      key={index}
                      className="bg-blue-100 text-blue-800 text-sm px-3 py-1 rounded-full"
                    >
                      {tag}
                    </span>
                  ))}
                </div>
                <div className="flex justify-between items-center">
                  <a
                    href={project.link || '#'}
                    target={project.link ? '_blank' : undefined}
                    rel={project.link ? 'noopener noreferrer' : undefined}
                    className="text-blue-600 font-semibold hover:text-blue-800 transition"
                  >
                    View Project →
                  </a>
                  <span className="text-xs text-gray-400">
                    {new Date(project.created_at).toLocaleDateString()}
                  </span>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </section>
  )
}

export default Projects